import React from "react";
import { bool } from "prop-types";
import Inline from "../Inline";
import { classes } from "../utils/classes";

const DropdownMenu = ({ className = "", shadow = true, children, ...props }) => (
	<ul className={classes("dropdown-menu", !shadow && "no-shadow", className)} {...props}>
		{children}
	</ul>
);

DropdownMenu.propTypes = {
	shadow: bool,
	...Inline.propTypes,
};

export default DropdownMenu;
